import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import EditUserModal from "../../../components/SiteUsers/EditUserModal";
import SiteUsersTableRow from "./SiteUsersTableRow";
import SiteUsersTableHead from "./SiteUsersTableHead";
import TableSkeleton from "../../../components/Skeleton/TableSkeleton";
import WarningModal from "./WarningModal";
import UserContactInfoModal from "../../../components/common/UserContactInfoModal";
import { TableBody, TableRow } from "@mui/material";
import { useMutation } from "@apollo/client";
import { DELETE_ACCOUNT_APPLICATION } from "../../../graphql/mutations";

const useStyles = makeStyles(() => ({
  root: {
    overflowX: "auto",
    position: "relative",
  },
  loadContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 40,
  },
}));

const SiteUsersTable = ({
  siteRoleOptions,
  fetchApplications,
  sortfield,
  ascending,
  setSortfield,
  setAscending,
  siteRolesRights,
  applications,
  siteUsersLoading, 
  onInviteSiteUser
  
}) => {
  const classes = useStyles();

  const [deleteApplication, { data: deleteApplicationData, loading: deleteLoading, error: errorDelete }] = useMutation(DELETE_ACCOUNT_APPLICATION);




  const [openEditUser, setOpenEditUser] = useState(false);
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [userContactDetails, setUserContactDetails] = useState(false);
  const [username, setUsername] = useState("");

  const [handledUsers, setHandledUsers] = useState([]);

  const handleCloseUserContactInfo = () => {
    setUserContactDetails(false);
  };

  const onRemoveSiteUser = (id) => {

    deleteApplication({ variables: { companyId: 20, id } });

  }

  useEffect(() => {
    if (deleteApplicationData) {
      fetchApplications();
    }

  }, [deleteApplicationData])

  const handleOpenUserDetails = username => {
    setUsername(username);
    setUserContactDetails(true);
  };

  return (
    <div className={classes.root}>
      <Table size="small">
        <SiteUsersTableHead
          sortfield={sortfield}
          ascending={ascending}
          setSortfield={setSortfield}
          setAscending={setAscending}
          siteRolesRights={siteRolesRights}
        />

        {siteUsersLoading ? (
          <TableBody>
            <TableRow>
              <TableCell className={classes.tdSkeleton} colSpan={9}>
                <TableSkeleton />
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody>
              {applications                
                .map(siteUser => {
              return (
                <SiteUsersTableRow
                  key={siteUser.id}
                  siteRoleOptions={siteRoleOptions}
                  siteUser={siteUser}
                  handleOpenEditUser={setOpenEditUser}
                  
                  setOpenWarningModal={setOpenWarningModal}
                  handleOpenUserDetails={handleOpenUserDetails}
                  siteRolesRights={siteRolesRights}
                  onRemoveSiteUser={onRemoveSiteUser}
                  onInviteSiteUser={onInviteSiteUser}
                />
              );
            })}
          </TableBody>
        )}
      </Table>
      {openWarningModal && (
        <WarningModal
          open={openWarningModal}
          handleClose={() => setOpenWarningModal(false)}
        />
      )}
      {openEditUser && (
        <EditUserModal open={openEditUser} setOpen={setOpenEditUser} />
      )}

      {userContactDetails && (
        <UserContactInfoModal
          open={userContactDetails}
          handleClose={() => handleCloseUserContactInfo()}
          username={username}
        />
      )}
    </div>
  );
};

SiteUsersTable.defaultProps = {
  siteRoleOptions: [],
};

SiteUsersTable.propTypes = {
  siteRoleOptions: PropTypes.arrayOf(PropTypes.shape({})),
  fetchSiteUsers: PropTypes.func.isRequired,
  setAscending: PropTypes.func.isRequired,
  setSortfield: PropTypes.func.isRequired,
  sortfield: PropTypes.string.isRequired,
  ascending: PropTypes.bool.isRequired,
};

export default SiteUsersTable;
